import { render, staticRenderFns } from "./PublicationAdFormatList.vue?vue&type=template&id=5ec5aa5e&"
import script from "./PublicationAdFormatList.vue?vue&type=script&lang=js&"
export * from "./PublicationAdFormatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports